<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE PEDIDOS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <!--PARA ORDENAR POR UN ELEMENTO-->
        <!--matSortActive="id" matSortDirection="asc"-->
        <table mat-table [dataSource]="dataSource" matSort matSortActive="ordered_at" matSortDirection="desc">

            <ng-container matColumnDef="numero_tank">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Num. de Tanque </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.numero_tank}} </td>
            </ng-container>

            <ng-container matColumnDef="external_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento ID </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.external_id}} </td>
            </ng-container>

            <ng-container matColumnDef="est_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element"  class="router-cell" routerLink="/establecimiento/{{element.est_id}}"> {{element.est_name}} </td>
            </ng-container>

            <ng-container matColumnDef="client_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.client_name}} </td>
            </ng-container>

            <ng-container matColumnDef="ordered_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>  Fecha del Pedido </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.ordered_at}} </td>
            </ng-container>

            <ng-container matColumnDef="litros">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Litros Pedidos</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.litros}} </td>
            </ng-container>

            <ng-container matColumnDef="cerveza">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.cerveza}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver tanque" color="warn" aria-label="Ver tanque" routerLink="/tanque/{{element.id}}">
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                    <button mat-mini-fab class="edit-btn" matTooltip="Editar tanque" color="warn" aria-label="Editar tanque" routerLink="{{element.id}}/editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[25,50,100]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="custom1">
        </mat-paginator>
    </div>
</ng-container>


